import {Zero, Components, Logger, Utils} from 'Zero';
import {
  applyEventOnAutocompleteChangePlace,
  applyRestrictionsOnAutocomplete,
  getSearchEngine,
  simpleGeocoding
} from "StoreLocatorSubcomponents/MapService";
import {IS_CHINA} from "../utils/Environment";


const Log = new Logger("MM3_ZSearch");

export default class ZSearch extends Components {


  get Messages() {
    return {
      "StoreLocator:Map:Ready": this.onMapInit,
      "StoreLocator:Init": this.onStoreLocatorInit,
      "Cart:Change:DeliveryMethod": this.onCartDeliveryMethodChanged
    };
  }


  get Selectors() {
    return {
      GeolocationButton: "button.geo-location",
      SearchButton: "button.search",
      SearchInput: "input[name=search]",
      cartClickAndCollectOpt: '.js-click_and_collect-opt'
    };
  }


  get InitialSearch() {
    return Zero.$state.StoreLocator.InitialSearch;
  }

  constructor(element) {
    super(element);

    this.GeoLocationBtn = $('#mm_my-geo');
    this.SearchBtn = $('.mm_sl-search-btn');
    this.InputSearch = $('#mm_sl-search-input');
    this.cartClickAndCollectOpt = $('.js-click_and_collect-opt');

    this.SearchBtn.on("click.searchBtn", (e) => {
      e.preventDefault();
      if (IS_CHINA) {
        this.onSearch(e);
      }
    })

    this.InputSearch.on('click.iSearch', (e) => {
      e.currentTarget.value = "";
    })

    this.GeoLocationBtn.on("click.search", (e) => {
      e.preventDefault();
      this.getUserLocation(true);
    })
  }

  onSearch(e) {
    let value = this.InputSearch.val();
    let p = null;
    let obj = null;
    let clicked = null;

    if (value.length > 0) {
      p = this.StoreLocator.navigate(value);
    } else {
      p = this.StoreLocator.navigate(this.InitialSearch);
    }

    clicked = document.body.classList.contains('t-cart');

    p.then((obj) => {
      this.onPlaceChanged({results: obj.results, fallbackRes: {name: value}, clicked});
    });
  }

  autoGeolocation() {
    const inCart = document.body.classList.contains('t-cart');

    if (navigator.geolocation && !inCart) {
      this.getUserLocation();
    } else {
      this.cartClickAndCollectOpt.on('click.clickcollect', (e) => {
        this.getUserLocation();
      })

      Log.e('geolocation should be disable or browser cannot be able to retrive position');
    }
  }


  onCartDeliveryMethodChanged(msg) {
    if (msg.method.startsWith("Click-and-Collect")) {
      this.getUserLocation(true);
    }
  }


  getUserLocation(clicked) {
    // MM30-894 force search by boundaries on get user location clicked = true
    clicked = true;

    this.StoreLocator.currentLocation({timeout: 30000}).then((location) => {
      Log.i("Browser geolocation:", location);

      let self = this;

      let coordinates = {
        lat: location.lat,
        lng: location.lng
      };

      simpleGeocoding(coordinates, function (result) {
        self.InputSearch.val(result);
      });

      this.StoreLocator.navigate(null, location).then((obj) => {
        this.onPlaceChanged({results: obj.results, clicked});
      });

    }, function () {
      Log.e("No current location enabled");
    });


  }

  onStoreLocatorInit(msg) {
    this.StoreLocator = msg.StoreLocator;
    Log.info("Got storelocator for ", this.element);
  }

  onMapInit() {

    const options = {};
    if (!IS_CHINA) {
      options.types = ['(regions)'];
    }

    const SearchEngine = getSearchEngine();
    let promise = new SearchEngine.Engine(this.StoreLocator, this.InputSearch, options);
    const engineName = SearchEngine.EngineName;
    promise.then((search) => {
      this.StoreLocator.addSearchEngine(engineName, this.searchEngine = search, options);
      this.bindStoreLocator();
      if (!IS_CHINA) {
        this.bindEngineSearch();
      }
      this.autoGeolocation();

      this.StoreLocator.navigate(this.InitialSearch).then((obj) => {
        this.onPlaceChanged({results: obj.results, isInitialSearch: true});
      });

    }, function () {
      Log.error(`Cannot bind ${engineName} engine`);
      throw `Cannot bind ${engineName} engine`;
    });
  }


  bindStoreLocator() {
    // pick up in store autocomplete query restriction
    const inCart = document.body.classList.contains('t-cart');

    if (inCart) {
      const country = document.body.dataset.website;
      applyRestrictionsOnAutocomplete(
        this.searchEngine.autocomplete,
        {
          'country': [country]
        }
      );
    }

    applyEventOnAutocompleteChangePlace(
      this.searchEngine.autocomplete,
      (e) => {

        let value = this.InputSearch.val();
        let p = null;
        let obj = null;
        let clicked = null;

        if (value.length > 0) {
          p = this.StoreLocator.navigate(value);
        } else {
          p = this.StoreLocator.navigate(this.InitialSearch);
        }

        clicked = document.body.classList.contains('t-cart');

        p.then((obj) => {
          this.onPlaceChanged({results: obj.results, fallbackRes: {name: value}, clicked});
        });
      }
    )
  }

  bindEngineSearch() {
    this.searchEngine.autocomplete.addListener('place_changed', (e) => {
      this.onSearch(e);
    });
  }

  onPlaceChanged({results, fallbackRes, clicked, isInitialSearch = false}) {
    const ris = this.StoreLocator.getFirstSearchEngine().processOnPlaceChangeResult(results, fallbackRes, clicked, this.StoreLocator.Map.Map, isInitialSearch);
    const {Address, Bounds, Center} = ris.locationToPatch;
    Zero.$state.StoreLocator.Location.Address = Address;
    Zero.$state.StoreLocator.Location.Bounds = Bounds;
    Zero.$state.StoreLocator.Location.Center = Center;
    Zero.$state.StoreLocator.Results = results;

    this.CAST("StoreLocator:Search:Place", {
      place: ris.geolocation,
      address: ris.address_text,
      searchedCountry: ris.searchedCountry
    });
  }

}

export {
  ZSearch
}


